<nav class="navbar navbar-expand-md navbar-dark bg-dark use-app-colors">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample04" aria-controls="navbarsExample04" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarsExample04">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item" [ngClass]="{'active': this.isActiveURL('/planes')}">
        <a class="nav-link" (click)="this.goTo('/planes')">Planes</a>
      </li>
    </ul>

    <ul class="navbar-nav">
      <li *ngIf="this.userIsLoggedIn()" class="nav-item" [ngClass]="{'active': this.isActiveURL('/perfil-de-usuario')}">
        <a class="nav-link" (click)="this.goTo('/perfil-de-usuario')">Editar perfil</a>
      </li>
      <li *ngIf="this.userIsLoggedIn()" class="nav-item">
        <a class="nav-link" (click)="this.logout()">Salir</a>
      </li>

      <li *ngIf="!this.userIsLoggedIn()" class="nav-item" [ngClass]="{'active': this.isActiveURL('/ingreso')}">
        <a class="nav-link" (click)="this.goTo('/ingreso')">Ingresar</a>
      </li>
      <li  *ngIf="!this.userIsLoggedIn()" class="nav-item" [ngClass]="{'active': this.isActiveURL('/registro')}">
        <a class="nav-link" (click)="this.goTo('/registro')">Registrarse</a>
      </li>
    </ul>
  </div>
</nav>
